import * as yup from 'yup'

const sampleRowSchema = yup.object().shape({
  container_color: yup.string().required('Container is required'),
  order_id: yup.string().required('Test type is required'),
  sample_type: yup.string().required('Sample type is required')
})

export const labSampleSchema = yup.object().shape({
  collection_date: yup.date().typeError('Date is required').required('Date is required'),
  collection_time: yup.string().required('Time is required'),
  lab_number: yup.string().required('Lab number is required'),
  note: yup.string(),
  patient_dob: yup.date().nullable(),
  patient_full_name: yup.string(),
  patient_gender: yup.string().nullable(),
  px_ref: yup.string().required('PX Ref is required'),
  samples: yup.array().of(sampleRowSchema).min(1, 'Add at least one sample')
})
